<div class="form-error">
  <!-- Required -->
  <ng-container
    *ngIf="
      formGroup &&
      field &&
      !formGroup.controls[field].valid &&
      formGroup.controls[field].touched &&
      formGroup.controls[field].errors?.required
    "
  >
    <p class="font-10 text-warn mt-5">
      {{ field | translate }}
      {{ 'ibSpecific.formErrors.isRequired' | translate }}
    </p>
  </ng-container>

  <!-- Pattern -->
  <ng-container
    *ngIf="
      formGroup &&
      field &&
      !formGroup.controls[field].valid &&
      formGroup.controls[field].touched &&
      formGroup.controls[field].errors?.pattern
    "
  >
    <p class="font-10 text-warn mt-5">
      {{ field | translate }}
      {{ 'ibSpecific.formErrors.doesntMatchExpectedPattern' | translate }}
    </p>
  </ng-container>

  <!-- Max Length -->
  <ng-container
    *ngIf="
      formGroup &&
      field &&
      !formGroup.controls[field].valid &&
      formGroup.controls[field].touched &&
      formGroup.controls[field].errors?.maxlength
    "
  >
    <p class="font-10 text-warn mt-5">
      {{ field | translate }}
      {{ 'ibSpecific.formErrors.exceededMaxLength' | translate }}
    </p>
  </ng-container>

  <!-- Min Length -->
  <ng-container
    *ngIf="
      formGroup &&
      field &&
      !formGroup.controls[field].valid &&
      formGroup.controls[field].touched &&
      formGroup.controls[field].errors?.minlength
    "
  >
    <p class="font-10 text-warn mt-5">
      {{ field | translate }}
      {{ 'ibSpecific.formErrors.doesntHaveEnoughCharacters' | translate }}
    </p>
  </ng-container>

  <!-- Not same -->
  <ng-container
    *ngIf="
      formGroup &&
      field &&
      !formGroup.controls[field].valid &&
      formGroup.controls[field].touched &&
      formGroup.controls[field].errors?.notSame
    "
  >
    <p class="font-10 text-warn text-center">
      {{ field | translate }} {{ 'ibSpecific.formErrors.notSame' | translate }}
    </p>
  </ng-container>

  <!-- Max number -->
  <ng-container
    *ngIf="
      formGroup &&
      field &&
      !formGroup.controls[field].valid &&
      formGroup.controls[field].touched &&
      formGroup.controls[field].errors?.max
    "
  >
    <p class="font-10 text-warn text-center">
      {{ field | translate }}
      {{ 'ibSpecific.formErrors.exceedLimit' | translate }}
    </p>
  </ng-container>
  <!-- Min Amount -->
  <ng-container
    *ngIf="
      formGroup &&
      field &&
      !formGroup.controls[field].valid &&
      formGroup.controls[field].touched &&
      formGroup.controls[field].errors?.min
    "
  >
    <p class="font-10 text-warn mt-5 mb-10">
      {{
        'ibSpecific.formErrors.minimumAmountRequired'
          | translate : { min: 1000 }
      }}
    </p>
  </ng-container>
</div>
